import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MARKET_BG_MAPPING_COLS_FOR_SELF_ASSESS } from 'src/app/common/models/tableColumns';
import { environment } from 'src/environments/environment';
import { AdministrationService } from '../administration.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import * as _ from 'lodash';


interface UPD {
  tfcLevel1: string;
  updId: string;
  updName: string;
  businessGroup?: string;
}

@Component({
  selector: 'app-self-assessment',
  templateUrl: './self-assessment.component.html',
  styleUrls: ['./self-assessment.component.scss']
})
export class SelfAssessmentComponent implements OnInit {

  filteredDataUpd: any[] = [];
  groupsData: any = '';
  marketBGMappingListColumns;
  marketBGMappingListData = [];
  loadingMessage = '';
  loading = false;
  filteredRows: any = [];
  selectedRows: any = [];
  buttonSelection = false;
  popupHeaderValue = 'Add';
  openPopUp = false;
  allBGs: any = [];
  selectedStatus: any;
  selectedMarkets = [];
  selectedBG;
  allMarketsList = [];
  updNameDataApi = '';
  selectedUpd: any;
  selectedCategories = [];
  categoryList = [];
  disableFC = false;
  editPopup = false;
  editCatSelection: any;
  editCatOptions = [];
  editMarketSelection: any;
  editMarketOptions = [];
  editBusinessGroup = '';
  disableSubmitInAdd = true;
  constructor(
    private apiService: AdministrationService,
    public matSnackBar: MatSnackBar,
    private http: HttpClient,
    public fb: FormBuilder,
    public router: Router,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.getMappingList();
    this.resetAddPopUpValues();
    this.updDropDown();
    this.getMarketData();
    this.selectedStatus = '1';
  }

  selectRow(row) {
    if (row._selection === null || row._selection === undefined) {
      this.buttonSelection = false;
    } else {
      this.buttonSelection = true;
    }
  }
  onFilter(event) {
    if (event.filters != null) {
      this.filteredRows = (Object.keys(event.filters).length === 0 ? [] : event.filteredValue);
    }
  }

  getMappingList() {
    this.marketBGMappingListColumns = MARKET_BG_MAPPING_COLS_FOR_SELF_ASSESS;
    this.marketBGMappingListData = [];
    this.loadingMessage = 'Getting Mapping Details';
    this.loading = true;
    const apiurl = environment.APIFAsT + '/getinstreportlist';
    this.apiService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      if (response.length !== 0) {
        this.marketBGMappingListData = response.map(respElem => {
          return {
            marketName: respElem.marketName,
            businessGroupName: respElem.division,
            businessGroup: respElem.businessGroup,
            categoryName: respElem.category,
            usageStatus: respElem.isActive === '1' ? 'Active' : 'Inactive',
            createdBy: respElem.submittedBy,
            createdDate: respElem.submittedDate ? this.datePipe.transform(new Date(respElem.submittedDate), 'dd-MM-yyyy') : '',
            modifiedBy: respElem.updatedBy,
            modifiedDate: respElem.updateDate && respElem.updateDate !== '1900-01-01T00:00:00' ? this.datePipe.transform(new Date(respElem.updateDate), 'dd-MM-yyyy') : '',
            // other fields useful for edit purpose
            marketId: respElem.marketId,
            divisionId: respElem.divisionId,
            categoryId: respElem.categoryId,
            isActive: respElem.isActive
          };
        });
      } else {
        this.marketBGMappingListData = [];
      }
    }, (error) => {
      this.loading = false;
    });
  }

  getMarketData() {
    this.loading = true;
    // this.loadingMessage = 'Getting Market Details';
    const apiurl = environment.APIFAsT + '/allmarkets';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.allMarketsList = response1;
    }, (error) => {
      this.loading = false;
    });
  }
  updDropDown() {
    const apiurl = environment.APIFAsT + '/getsubstancesearchupdsfornonplmbg';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.allBGs = response1;
      if (this.editPopup && this.editBusinessGroup) {
        this.selectedBG = this.getBusinessGroupOption(this.editBusinessGroup);
      }
    });
  }
  updSelected(event): void {
    this.updNameDataApi = event.value.updName;
    this.getGroupDataFormulationCategory(event.value);
    this.selectedCategories = [];
  }

  getGroupDataFormulationCategory(typeValue) {
    this.loading = true;
    this.loadingMessage = 'Getting Categories';
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/1/' + typeValue.updId;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.categoryList = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  resetAddPopUpValues() {
    this.openPopUp = false;
    this.editPopup = false;
    this.editBusinessGroup = '';
    this.selectedBG = null;
    this.selectedCategories = [];
    this.selectedMarkets = [];
    this.selectedStatus = '1';
  }
  openAddPopup() {
    this.openPopUp = true;
    this.popupHeaderValue = 'Add';
    this.disableFC = true;
    this.selectedBG = null;
    this.editPopup = false;
  }

  openEditPopup(tableData) {
    this.editPopup = true;
    const rowData = tableData._selection;
    this.editBusinessGroup = rowData.businessGroup || '';
    this.selectedBG = this.getBusinessGroupOption(this.editBusinessGroup);
    this.editCatOptions = [{ categoryId: rowData.categoryId, categoryName: rowData.categoryName }];
    this.editCatSelection = { categoryId: rowData.categoryId, categoryName: rowData.categoryName };

    this.editMarketOptions = [{ marketId: rowData.marketId, marketName: rowData.marketName }];
    this.editMarketSelection = { marketId: rowData.marketId, marketName: rowData.marketName };
    this.selectedStatus = rowData.isActive;
  }

  private getBusinessGroupOption(businessGroup: string) {
    const normalizedBusinessGroup = String(businessGroup).toLowerCase();
    return (this.allBGs || []).find((option: UPD) =>
      String(option.businessGroup || '').toLowerCase() === normalizedBusinessGroup ||
      String(option.updName || '').toLowerCase() === normalizedBusinessGroup) || null;
  }

  clearSelectedMarkets() {
    this.selectedMarkets = [];
    this.disableSubmitInAdd = true;

  }
  clearSelectedCateogries() {
    this.selectedCategories = [];
    this.disableSubmitInAdd = true;
  }
  clearSelectedBG() {
    this.selectedBG = null;
    this.selectedCategories = [];
    this.disableFC = true;
    this.disableSubmitInAdd = true;
  }

  enableOrDisable() {
    if (this.selectedBG) {
      this.disableFC = false;
    }
    if (this.selectedBG && this.selectedCategories.length !== 0 && this.selectedMarkets.length !== 0) {
      this.disableSubmitInAdd = false;
    } else {
      this.disableSubmitInAdd = true;
    }
  }

  submitPopUpValuesAdd() {
    this.loading = true;
    this.loadingMessage = 'Submitting';
    const divisionId = this.selectedBG.updId;
    const isActive = this.selectedStatus;
    const allObjs = [];

    for (let i = 0; i < this.selectedCategories.length; i++) {
      const catId = this.selectedCategories[i].tfcLevel1Id;
      for (let j = 0; j < this.selectedMarkets.length; j++) {
        const newObj = {
          divisionId: divisionId,
          isActive: isActive,
          categoryId: catId,
          marketId: this.selectedMarkets[j].marketId
        };
        allObjs.push(newObj);
      }
    }
    // Do duplicacy check only when there is only one entry is being added
    let isDuplicate = false;
    if (allObjs.length === 1) {
      isDuplicate = this.checkDuplicateOrNot(allObjs[0]);
    }
    if (isDuplicate) {
      this.loading = false;
      this.openPopUp = false;
      const msg = 'Self Assessment mapping is already present in database.';
      this.matSnackBar.open(msg, 'close', {
        duration: 6000,
        panelClass: ['success']
      });
    } else {
      this.addPopupValuesAPICall(allObjs);
    }
  }

  addPopupValuesAPICall(allObjs) {
    const apiurl = environment.APIFAsT + '/addoreditinstantreport';
    const apiBody = allObjs;
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      this.openPopUp = false;
      const msg = this.popupHeaderValue === 'Add' ? 'Successfully Added.' : 'Successfully Updated.';
      this.matSnackBar.open(msg, 'close', {
        duration: 3000,
        panelClass: ['success']
      });
      this.getMappingList();
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  submitPopUpValuesEdit() {
    this.editPopup = false;
    this.loadingMessage = 'Submitting';
    this.loading = true;
    const apiurl = environment.APIFAsT + '/addoreditinstantreport';
    const apiBody = [{
      divisionId: this.selectedBG.updId,
      isActive: this.selectedStatus,
      categoryId: this.editCatSelection.categoryId,
      marketId: this.editMarketSelection.marketId
    }];
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      this.openPopUp = false;
      const msg = 'Successfully Updated.';
      this.matSnackBar.open(msg, 'close', {
        duration: 3000,
        panelClass: ['success']
      });
      this.getMappingList();
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  checkDuplicateOrNot(target) {
    const matches = this.marketBGMappingListData.filter(obj =>
      obj.marketId === target.marketId &&
      obj.divisionId === target.divisionId &&
      obj.categoryId === target.categoryId &&
      obj.isActive === target.isActive
    );
    const exists = matches.length > 0;
    return exists;
  }

  customSort(event: any) {
  console.log(event);
  event.data.sort((a, b) => {
    const value1 = a[event.field];
    const value2 = b[event.field];

    // Detect date format and perform date comparison if both values are date
    const isDateColumn = /^\d{2}-\d{2}-\d{4}$/.test(value1);
    const isDateColumn2 = /^\d{2}-\d{2}-\d{4}$/.test(value2);
    if (isDateColumn && isDateColumn2) {
      const parseDate = (d: string) => {
        const [day, month, year] = d.split('-').map(Number);
        return new Date(year, month - 1, day);
      };
      return (parseDate(value1).getTime() - parseDate(value2).getTime()) * event.order;
    }

    return value1.localeCompare(value2) * event.order;
  });
}
}
